import { render, staticRenderFns } from "./DialogEditUserNotes.vue?vue&type=template&id=72e321a2&scoped=true"
import script from "./DialogEditUserNotes.js?vue&type=script&lang=js&external"
export * from "./DialogEditUserNotes.js?vue&type=script&lang=js&external"
import style0 from "./DialogEditUserNotes.vue?vue&type=style&index=0&id=72e321a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e321a2",
  null
  
)

export default component.exports